import { Injectable } from '@angular/core';

export interface MenuI {
  id: number;
  controller?: string;
  state: string;
  name: string;
  type: string;
  icon: string;
  expanded: boolean;
  content: SubMenuI[];
  roles: string[];
}

export interface SubMenuI {
  id: number;
  controller?: string;
  state: string;
  name: string;
  type: string;
  icon: string;
  roles: string[];
}

const MENUITEMSDESIGN = [
  { id:0, controller: '/design',state: 'dashboard', name: 'Dashboard', type: 'link', icon: 'av_timer', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:1, controller: '/design',state: 'button', type: 'link', name: 'Buttons', icon: 'crop_7_5', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:2, controller: '/design',state: 'grid', type: 'link', name: 'Grid List', icon: 'view_comfy', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:3, controller: '/design',state: 'lists', type: 'link', name: 'Lists', icon: 'view_list', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:4, controller: '/design',state: 'menu', type: 'link', name: 'Menu', icon: 'view_headline', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:5, controller: '/design',state: 'tabs', type: 'link', name: 'Tabs', icon: 'tab', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:6, controller: '/design',state: 'stepper', type: 'link', name: 'Stepper', icon: 'web', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:7, controller: '/design',state: 'expansion', type: 'link', name: 'Expansion Panel', icon: 'vertical_align_center', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:8, controller: '/design',state: 'chips', type: 'link', name: 'Chips', icon: 'vignette', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:9, controller: '/design',state: 'toolbar', type: 'link', name: 'Toolbar', icon: 'voicemail', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:10, controller: '/design',state: 'progress-snipper', type: 'link', name: 'Progress snipper', icon: 'border_horizontal', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:11, controller: '/design',state: 'progress', type: 'link', name: 'Progress Bar', icon: 'blur_circular', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:12, controller: '/design',state: 'dialog', type: 'link', name: 'Dialog', icon: 'assignment_turned_in', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:13, controller: '/design',state: 'tooltip', type: 'link', name: 'Tooltip', icon: 'assistant', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:14, controller: '/design',state: 'snackbar', type: 'link', name: 'Snackbar', icon: 'adb', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:15, controller: '/design',state: 'slider', type: 'link', name: 'Slider', icon: 'developer_mode', content: [], expanded: false, roles:['ADMINISTRADOR']},
  { id:16, controller: '/design',state: 'slide-toggle', type: 'link', name: 'Slide Toggle', icon: 'all_inclusive', content: [], expanded: false, roles:['ADMINISTRADOR'] },
  { id:17, controller: '',state: '',name: 'Mantenedores', type: 'container',icon: 'settings',  
    content: [
      { id:18, controller: '/mantenedores/', state: 'usuarios',name: 'Usuarios',type: 'link',icon: 'person', content: [], expanded: false, roles:['ADMINISTRADOR'] }
    ], expanded: false, roles:['ADMINISTRADOR']
  }
];

const MENUITEMS = [
  { id:0, controller: '/',state: 'home',name: 'Inicio',type: 'link',icon: 'home', content: [], expanded: false, roles:['ADMINISTRADOR','ADMINISTRADOR MDA NACIONAL','ADMINISTRADOR MDA REGIONAL','USUARIO','CAIP'] },
  { id:1, controller: '/',state: 'empty',name: 'Mantenedores', type: 'container',icon: 'settings',  
    content: [
      { id:2, controller: '/mantenedores/', state: 'usuarios',name: 'Usuarios',type: 'link',icon: 'person', content: [], expanded: false, roles:['ADMINISTRADOR','ADMINISTRADOR MDA NACIONAL','ADMINISTRADOR MDA REGIONAL'] },
      { id:3, controller: '/mantenedores/', state: 'perfiles',name: 'Perfiles',type: 'link',icon: 'supervisor_account', content: [], expanded: false, roles:['ADMINISTRADOR'] },
      { id:4, controller: '/mantenedores/', state: 'logs',name: 'Logs',type: 'link',icon: 'format_list_numbered', content: [], expanded: false, roles:['ADMINISTRADOR'] },
      { id:5, controller: '/mantenedores/', state: 'sistema',name: 'Sistema',type: 'link',icon: 'desktop_windows', content: [], expanded: false, roles:['ADMINISTRADOR'] }
    ], expanded: false, roles:['ADMINISTRADOR','ADMINISTRADOR MDA NACIONAL','ADMINISTRADOR MDA REGIONAL'] 
  }
];      

@Injectable()
export class MenuItems {

  getMenuitem(): MenuI[] {
    let MENUF = MENUITEMS;
    let IDM = sessionStorage.getItem('IDM');
    if(IDM != null) {
      let num = Number.parseInt(IDM);
      MENUF.forEach(item => {
        if(item.id == num) {
          item.expanded = true;
        } else {
          item.expanded = false;
        }
        item.content.forEach(subMenu => {
          if(subMenu.id == num) {
            subMenu.expanded = true;
          } else {
            subMenu.expanded = false;
          }
        });
      });
    } else {
      MENUF.forEach(item => {
        item.expanded = false;
        item.content.forEach(subMenu => {
          subMenu.expanded = false;
        });
      });
    }  
    return MENUF;
  }
}